module.exports = __webpack_public_path__ + "img/reset.68ca6f63.svg";